@if (stepperOn) {
    @if (dynamicFieldsForPayment.length > 1) {
        <mat-stepper linear #collectorStepper>
            @for (section of dynamicFieldsForPayment; let sectionIndex = $index; let last = $last; track sectionIndex) {
                <mat-step [stepControl]="formGroups[$index] || null">
                    <ng-template matStepLabel>{{ section?.label || 'Step' }}</ng-template>
                    <app-dynamic-form
                        #dynamicForms
                        [modelForm]="dynamicFieldsForPayment[$index]"
                        [customerReferenceRequired]="isCustomerReferenceRequired"
                    />
                    @if (withButtons) {
                        <div class="d-flex justify-content-end">
                            @if ($index > 0) {
                                <button
                                    color="primary"
                                    class="me-2"
                                    appMatStrokedButtonBorder
                                    mat-button
                                    matStepperPrevious
                                >
                                    Back
                                </button>
                            }
                            @if (last) {
                                <button color="primary" mat-flat-button matStepperNext (click)="onSubmitCollector()">
                                    Continue
                                </button>
                            } @else {
                                <button
                                    color="primary"
                                    mat-flat-button
                                    matStepperNext
                                    (click)="onContinue(formGroups[$index] || null)"
                                >
                                    Next
                                </button>
                            }
                        </div>
                    }
                </mat-step>
            }
        </mat-stepper>
    } @else if (!!dynamicFieldsForPayment[0]) {
        <app-dynamic-form
            #dynamicForms
            [modelForm]="dynamicFieldsForPayment[0]"
            [customerReferenceRequired]="isCustomerReferenceRequired"
        />
        @if (withButtons) {
            <div class="d-flex justify-content-end">
                <button appMatStrokedButtonBorder mat-button color="primary" class="me-2" (click)="onCancelProccess()">
                    Cancel
                </button>
                <button color="primary" mat-flat-button (click)="onSubmitCollector()">Continue</button>
            </div>
        }
    }
} @else {
    <div class="information-collector my-5">
        @for (section of dynamicFieldsForPayment; let sectionIndex = $index; let last = $last; track sectionIndex) {
            <div>
                <h2 class="mat-headline-6 mb-0 d-flex">{{ section?.label || 'Step' }}</h2>
                <app-dynamic-form
                    #dynamicForms
                    [modelForm]="dynamicFieldsForPayment[$index]"
                    [customerReferenceRequired]="isCustomerReferenceRequired"
                />
                @if (!last) {
                    <mat-divider class="m-0 my-3" />
                }
            </div>
        }
    </div>
}
